<template>
    <div class="text-primary">
        <targeting-router-link v-if="params.data.pendingTransactions.length > 0" :to="{...PAYMENTS}">
            ({{ formatCurrency(params.data.pendingAmount) }})
        </targeting-router-link>
    </div>
</template>

<script setup lang="ts">

import {provide} from 'vue'
import { TargetingRouterLink } from '@tritt/multipanel'
import {SubAccountLine} from '@/subaccount/outstandingBalance/SubAccountLine'
import {PAYMENTS} from '@/bank'
import {formatCurrency} from '@/services/formatter.service'

const props = defineProps({
    params: {
        type: Object as () => {
            data: SubAccountLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

</script>

<style scoped>

</style>